import { render, staticRenderFns } from "./CreateTechnicalDevicePage.vue?vue&type=template&id=51b59787"
import script from "./CreateTechnicalDevicePage.vue?vue&type=script&lang=js"
export * from "./CreateTechnicalDevicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports